var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloser(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 38,
    viewBox: "0 0 38 38",
    width: 38,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipRule: "evenodd",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m19 37c9.9411 0 18-8.0589 18-18 0-9.94113-8.0589-18-18-18-9.94113 0-18 8.05887-18 18 0 9.9411 8.05887 18 18 18z",
    fill: "#fff",
    fillOpacity: 0.950861,
    stroke: "#e5e5e5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19 17.7432 4.3212-4.3213.7071-.7071 1.2571 1.2571-.7071.7071-4.3212 4.3212 4.3212 4.3212.7071.7071-1.2571 1.2571-.7071-.7071-4.3212-4.3212-4.3212 4.3212-.7071.7071-1.2571-1.2571.7071-.7071 4.3212-4.3212-4.3212-4.3212-.7071-.7071 1.2571-1.2571.7071.7071z",
    fill: "#5e6064"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloser);
export default __webpack_public_path__ + "static/media/closer.51b6e042e66c38a58823ba5477d9bcf9.svg";
export { ForwardRef as ReactComponent };